/***
*
*   useAPI hook
*   Interact with API calls – handle errors, return loading state and data
*
*   PROPS
*   url: endpoint url
*   method: get, post, put etc.. (default: get)
*
**********/

import { useState, useEffect, useContext, useCallback, useRef } from 'react';
import Axios from 'axios';
import { ViewContext, AuthContext } from 'components/lib';

export function useAPI(url, userAuth, method='GET'){

  // wrap in useRef to prevent triggering useEffect multiple times  
  const context = useRef(useContext(ViewContext));
  const authContext = useRef(useContext(AuthContext));
  const [state, setState] = useState({ data: null, loading: false, success: true })



  const fetch = useCallback(async () => {
    try {

      if (!url){

        setState({ data: null, loading: false, success: true });
        return false;

      }

      setState({ loading: true });
      if(userAuth && !userAuth.user){
        //console.log("No user");
        setState({ data: null, loading: false, success: false });
        return;
      }

      const res = await Axios({

        url: url,
        method: method || 'get',
        
      })
      //console.log(res.data);

      setState({ data: res.data.data, loading: false, success: res.data.success ? res.data.success : false });

    }
    catch (err){

      context?.current &&
      context.current.handleError(err);

    }
  }, [url, method, context]);

  useEffect(() => {

    fetch()

  }, [fetch]);

  return state

}
